import React from 'react';
import { Card, Typography, Space } from 'antd';
import {
  EnvironmentOutlined,
  BookOutlined,
  CheckSquareOutlined,
  ShoppingOutlined,
  FileTextOutlined,
  PictureOutlined
} from '@ant-design/icons';
import theme from '../theme';

const { Title, Text, Paragraph } = Typography;

function TractorWelcome() {
  const features = [
    { icon: <EnvironmentOutlined />, title: 'Field Mapping', desc: 'Interactive maps with GPS tracking' },
    { icon: <BookOutlined />, title: 'Journal', desc: 'Record observations and activities' },
    { icon: <CheckSquareOutlined />, title: 'Task Management', desc: 'Track todos and activities' },
    { icon: <ShoppingOutlined />, title: 'Packlists', desc: 'Organize equipment and supplies' },
    { icon: <FileTextOutlined />, title: 'Decision Log', desc: 'Document important decisions' },
    { icon: <PictureOutlined />, title: 'Image Gallery', desc: 'Store and organize field photos' },
  ];

  return (
    <div className="tractor-welcome" style={{
      padding: '60px 20px',
      maxWidth: '1200px',
      margin: '0 auto'
    }}>
      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <img src="/thefarm.png" alt="The Farm" style={{ maxWidth: '500px', width: '100%', height: 'auto', marginBottom: '30px' }} />
          <Title level={2} style={{ color: theme.colors.primary, marginBottom: '16px' }}>
            Welcome to Ovaielo Agritech
          </Title>
          <Paragraph style={{ fontSize: '16px', color: theme.colors.textSecondary }}>
            Your comprehensive agricultural planning and field management solution.
            <br />
            Please log in above to access your tools.
          </Paragraph>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
          gap: '20px',
          marginTop: '20px'
        }}>
          {features.map((feature, index) => (
            <Card
              key={index}
              hoverable
              style={{
                borderColor: theme.colors.lightGrey,
                borderRadius: theme.borderRadius.md,
              }}
              bodyStyle={{ textAlign: 'center', padding: '24px' }}
            >
              <div style={{
                fontSize: '40px',
                color: theme.colors.primary,
                marginBottom: '16px'
              }}>
                {feature.icon}
              </div>
              <Title level={4} style={{ color: theme.colors.primary, marginBottom: '8px' }}>
                {feature.title}
              </Title>
              <Text style={{ color: theme.colors.textSecondary }}>
                {feature.desc}
              </Text>
            </Card>
          ))}
        </div>
      </Space>
    </div>
  );
}

export default TractorWelcome;